import { render, staticRenderFns } from "./TheSnapshotRenameButton.vue?vue&type=template&id=39198b40&"
import script from "./TheSnapshotRenameButton.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotRenameButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports